export default "__VITE_ASSET__BR_nO389__"